import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { reportImgCloudPageView } from '../services/pageViews';
import { resolveImgCloudPageKey } from './routeMetadata';

const PageViewTracker = () => {
  const { pathname } = useLocation();
  const pageKey = resolveImgCloudPageKey(pathname);

  useEffect(() => {
    if (pageKey) {
      reportImgCloudPageView(pageKey);
    }
  }, [pageKey, pathname]);

  return null;
};

export default PageViewTracker;
